import { render, staticRenderFns } from "./InvestmentSuggestionsView.vue?vue&type=template&id=9487819a&scoped=true"
import script from "./InvestmentSuggestionsView.vue?vue&type=script&lang=ts"
export * from "./InvestmentSuggestionsView.vue?vue&type=script&lang=ts"
import style0 from "./InvestmentSuggestionsView.vue?vue&type=style&index=0&id=9487819a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9487819a",
  null
  
)

export default component.exports